/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section links_list_js
	 ********************************************/
	(function ProductFitmentModule() {
		var $fitmentModules;

		/********************************************
		.* Attach
		.* -----------------------------------------
		.* Attach events to each module instance
		.********************************************/
		function attachEvents() {
			$fitmentModules = rp$('.product-fitment-module');

			rp$.each($fitmentModules, function DropDownMenu_Iterator(idx, fitmentModule) {
				var $fitmentModule = rp$(fitmentModule);
				var wrapper = $fitmentModule.find('.fitment-table-wrap');

				$fitmentModule.on('click', '.fitment-expander', function Expand_Fitment() {
					if(wrapper.hasClass('fitment-closed')){
						wrapper.removeClass('fitment-closed');
					} else {
						wrapper.addClass('fitment-closed');
					}
				});
			});
		}

		function HandleNewProductImagesHtml(evt, html) {
			rp$('.product-fitment-module').html(html);
			attachEvents();
		}

		rp$(document).off('setProductFitment:html', HandleNewProductImagesHtml);
		rp$(document).on('setProductFitment:html', HandleNewProductImagesHtml);

		$onReady({
			rp$, window,
			label: 'product_fitment',
			fn: attachEvents,
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
